import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCheckCircleWithDiamond(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={62} height={54} fill="none" {...props}>
      <path
        fill="#169563"
        d="M.38 3.538 6.647.09a.73.73 0 0 1 .706 0l6.267 3.447a.733.733 0 0 1 .25 1.058l-6.267 9.087a.732.732 0 0 1-1.206 0L.13 4.597a.733.733 0 0 1 .25-1.06Z"
      />
      <circle
        cx={37}
        cy={26}
        r={22.5}
        stroke="url(#CheckCircleWithDiamond_svg__a)"
        strokeWidth={5}
      />
      <path stroke="#0C1C43" strokeLinecap="round" strokeLinejoin="round" d="m28 28 5.7 6L47 18" />
      <defs>
        <linearGradient
          id="CheckCircleWithDiamond_svg__a"
          x1={37}
          x2={37}
          y1={1}
          y2={51}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCheckCircleWithDiamond);
export default ForwardRef;
